/* ══════════════════════════════════════════
        SHOPIFY THEME JS
   ══════════════════════════════════════════ */

document.addEventListener('DOMContentLoaded', () => {

  /* ── CUSTOM CURSOR ── */
  /*
  const cursor = document.getElementById('cursor');
  const ring = document.getElementById('cursor-ring');
  if (cursor && ring) {
    let mx = 0, my = 0, rx = 0, ry = 0;
    document.addEventListener('mousemove', e => {
      mx = e.clientX; my = e.clientY;
      cursor.style.left = mx + 'px';
      cursor.style.top  = my + 'px';
    });
    (function animRing() {
      rx += (mx - rx) * 0.12;
      ry += (my - ry) * 0.12;
      ring.style.left = rx + 'px';
      ring.style.top  = ry + 'px';
      requestAnimationFrame(animRing);
    })();
    document.querySelectorAll('a, button, .bs-card, .c-dot, .step-dot, .border-opt').forEach(el => {
      el.addEventListener('mouseenter', () => {
        cursor.style.transform = 'translate(-50%,-50%) scale(2)';
        ring.style.width = '60px'; ring.style.height = '60px';
        ring.style.borderColor = 'rgba(212,168,75,0.8)';
      });
      el.addEventListener('mouseleave', () => {
        cursor.style.transform = 'translate(-50%,-50%) scale(1)';
        ring.style.width = '36px'; ring.style.height = '36px';
        ring.style.borderColor = 'rgba(212,168,75,0.5)';
      });
    });
  }
*/ 
  /* particles removed for performance */

  /* ── HEADER SCROLL ── */
  const hdr = document.getElementById('main-header');
  if (hdr) {
    window.addEventListener('scroll', () => {
      hdr.classList.toggle('scrolled', window.scrollY > 60);
    });
  }

  /* ── MOBILE NAV TOGGLE ── */
  const navToggle = document.getElementById('nav-toggle');
  const mainNav   = document.getElementById('main-nav');
  if (navToggle && mainNav) {
    navToggle.addEventListener('click', () => {
      mainNav.classList.toggle('open');
    });
  }

  /* ── HERO 3D CARD MOUSE (desktop) ── */
  const heroWrap = document.getElementById('hero-card-wrap');
  if (heroWrap) {
    // Desktop: follow mouse
    document.addEventListener('mousemove', e => {
      const rect = heroWrap.getBoundingClientRect();
      const cx = rect.left + rect.width / 2;
      const cy = rect.top  + rect.height / 2;
      const dx = (e.clientX - cx) / 400;
      const dy = (e.clientY - cy) / 400;
      heroWrap.style.animation = 'none';
      heroWrap.style.transform = `rotateY(${-15+dx*30}deg) rotateX(${8-dy*20}deg)`;
    });

    // Mobile: gyroscope tilt
    if (window.DeviceOrientationEvent) {
      window.addEventListener('deviceorientation', function(e) {
        if (!e.gamma && !e.beta) return;
        const ry = Math.max(-25, Math.min(25, e.gamma * 0.6)); // left-right
        const rx = Math.max(-15, Math.min(15, (e.beta - 45) * 0.4)); // front-back
        heroWrap.style.animation = 'none';
        heroWrap.style.transform = `rotateY(${ry}deg) rotateX(${rx}deg)`;
      }, true);
    }

    // Mobile: touch drag tilt on the card itself
    let touchStartX = 0, touchStartY = 0;
    heroWrap.addEventListener('touchstart', function(e) {
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      heroWrap.style.animation = 'none';
    }, { passive: true });
    heroWrap.addEventListener('touchmove', function(e) {
      const dx = (e.touches[0].clientX - touchStartX) / 8;
      const dy = (e.touches[0].clientY - touchStartY) / 8;
      const ry = Math.max(-30, Math.min(30, dx));
      const rx = Math.max(-20, Math.min(20, -dy + 8));
      heroWrap.style.transform = `rotateY(${ry}deg) rotateX(${rx}deg)`;
    }, { passive: true });
    heroWrap.addEventListener('touchend', function() {
      // Spring back to idle animation after touch
      heroWrap.style.transform = '';
      heroWrap.style.animation = 'heroCardIdle 6s ease-in-out infinite';
    }, { passive: true });

    // iOS 13+ requires permission for DeviceOrientationEvent
    document.addEventListener('touchend', function requestGyro() {
      if (typeof DeviceOrientationEvent !== 'undefined' &&
          typeof DeviceOrientationEvent.requestPermission === 'function') {
        DeviceOrientationEvent.requestPermission()
          .then(function(state) {
            if (state === 'granted') {
              window.addEventListener('deviceorientation', function(e) {
                if (!e.gamma) return;
                const ry = Math.max(-25, Math.min(25, e.gamma * 0.6));
                const rx = Math.max(-15, Math.min(15, (e.beta - 45) * 0.4));
                heroWrap.style.animation = 'none';
                heroWrap.style.transform = `rotateY(${ry}deg) rotateX(${rx}deg)`;
              }, true);
            }
          }).catch(function(){});
      }
      document.removeEventListener('touchend', requestGyro);
    }, { once: true });
  }

  /* ── PROCESS SCROLL STEPS ── */
  const cardGrads = [];
  let currentStep = 0;

  window.setStep = function(n) {
    const prev = currentStep;
    currentStep = n;

    // Text steps
    document.querySelectorAll('.step-slide').forEach((s, i) => s.classList.toggle('active', i === n));
    document.querySelectorAll('.step-dot').forEach((d, i)   => d.classList.toggle('active', i === n));

    // Card image vertical slide
    const slides = document.querySelectorAll('.proc-card-slide');
    if (slides.length > 0) {
      slides.forEach((s, i) => {
        s.style.transition = 'transform 0.55s cubic-bezier(0.25,0.46,0.45,0.94)';
        if (i === n) {
          s.style.transform = 'translateY(-100%)';
          requestAnimationFrame(() => requestAnimationFrame(() => {
            s.style.transform = 'translateY(0%)';
          }));
        } else if (i === prev) {
          s.style.transform = 'translateY(100%)';
        } else {
          s.style.transform = 'translateY(-100%)';
        }
      });
    }
  };

  // Auto-play — changes every 3 seconds, fully automatic, no scroll needed
  const totalProcSteps = Math.max(
    document.querySelectorAll('.step-slide').length,
    document.querySelectorAll('.proc-card-slide').length,
    7
  );

  setInterval(() => {
    if (document.getElementById('process-section')) {
      setStep((currentStep + 1) % totalProcSteps);
    }
  }, 3000);

  /* ── CAROUSEL ── */
  (function initCarousel() {
    const stage   = document.getElementById('carousel-stage');
    const dotsWrap = document.getElementById('carousel-dots');
    if (!stage || !dotsWrap) return;

    const cards = Array.from(stage.querySelectorAll('.bs-card'));
    const total = cards.length;
    let active = Math.min(2, total - 1);

    cards.forEach((_, i) => {
      const d = document.createElement('div');
      d.className = 'c-dot' + (i === active ? ' active' : '');
      d.addEventListener('click', () => goTo(i));
      dotsWrap.appendChild(d);
    });

    function render() {
      cards.forEach((card, i) => {
        const diff = i - active;
        card.classList.remove('active','pos--1','pos--2','pos--3','pos-1','pos-2','pos-3');
        if      (diff ===  0) card.classList.add('active');
        else if (diff === -1) card.classList.add('pos--1');
        else if (diff === -2) card.classList.add('pos--2');
        else if (diff <  -2) card.classList.add('pos--3');
        else if (diff ===  1) card.classList.add('pos-1');
        else if (diff ===  2) card.classList.add('pos-2');
        else                   card.classList.add('pos-3');
      });
      dotsWrap.querySelectorAll('.c-dot').forEach((d,i) => d.classList.toggle('active', i === active));
    }

    function goTo(idx) {
      // Wrap around — loop from last card back to first and vice versa
      if (idx < 0) idx = total - 1;
      if (idx >= total) idx = 0;
      active = idx;
      render();
    }

    document.getElementById('prev-btn')?.addEventListener('click', () => goTo(active-1));
    document.getElementById('next-btn')?.addEventListener('click', () => goTo(active+1));
   
    document.addEventListener('keydown', e => {
      if (e.key === 'ArrowLeft')  goTo(active-1);
      if (e.key === 'ArrowRight') goTo(active+1);
    });

    let touchX = null;
    stage.addEventListener('touchstart', e => { touchX = e.touches[0].clientX; }, { passive: true });
    stage.addEventListener('touchend',   e => {
      if (touchX === null) return;
      const dx = e.changedTouches[0].clientX - touchX;
      if (Math.abs(dx) > 40) goTo(active + (dx < 0 ? 1 : -1));
      touchX = null;
    }, { passive: true });

    cards.forEach((card, i) => {
  card.addEventListener('click', () => {
    if (i !== active) {
      goTo(i);
    } else {
      if (window.innerWidth <= 768) {
        card.classList.toggle('tapped');
      }
    }
  });
});

    // Auto-play — loops forever, pauses on hover
    let autoPlay = setInterval(() => goTo(active + 1), 3500);
    const carouselWrap = stage.closest('.carousel-wrap');
    if (carouselWrap) {
      carouselWrap.addEventListener('mouseenter', () => clearInterval(autoPlay));
      carouselWrap.addEventListener('mouseleave', () => {
        clearInterval(autoPlay);
        autoPlay = setInterval(() => goTo(active + 1), 3500);
      });
    }

    render();
  })();

  /* ── SCROLL REVEAL ── */
  const revealObs = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) entry.target.classList.add('in-view');
    });
  }, { threshold: 0.12 });
  document.querySelectorAll('.reveal').forEach(el => revealObs.observe(el));

  /* ── MINI CART DRAWER ── */
  const cartDrawer  = document.getElementById('cart-drawer');
  const cartOverlay = document.getElementById('cart-overlay');
  const cartClose   = document.getElementById('cart-close');
  const cartLink    = document.getElementById('cart-link');

  window.openCartDrawer = function() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('open');
    refreshCartDrawer();
  };
  window.closeCartDrawer = function() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('open');
  };

  if (cartOverlay) cartOverlay.addEventListener('click', closeCartDrawer);
  if (cartClose)   cartClose.addEventListener('click', closeCartDrawer);

  if (cartLink) {
    cartLink.addEventListener('click', e => {
      e.preventDefault();
      openCartDrawer();
    });
  }

  window.refreshCartDrawer = function() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        updateCartCount(cart.item_count);
        renderCartDrawer(cart);
      });
  };

  window.updateCartCount = function(count) {
    const badge = document.getElementById('cart-count');
    if (badge) {
      badge.textContent = count > 0 ? count : '';
      badge.style.display = count > 0 ? 'flex' : 'none';
    }
  };

  function renderCartDrawer(cart) {
    const body   = document.getElementById('cart-body');
    const footer = document.getElementById('cart-footer');
    const subtotalEl = document.getElementById('cart-subtotal-val');
    if (!body) return;

    if (cart.item_count === 0) {
      body.innerHTML = '<p class="cart-empty-msg">Your cart is empty.</p>';
      if (footer) footer.style.display = 'none';
      return;
    }

    const formatMoney = cents => '$' + (cents / 100).toFixed(2);

    body.innerHTML = cart.items.map(item => `
      <div class="cart-drawer-item">
        ${item.image ? `<img src="${item.image}" alt="${item.title}">` : ''}
        <div class="cart-item-info">
          <div class="cart-item-info-title">${item.product_title}</div>
          ${Object.entries(item.properties||{}).filter(([k,v])=>v).map(([k,v])=>`<div class="cart-item-info-props">${k}: ${v}</div>`).join('')}
          <div class="cart-item-info-price">${formatMoney(item.line_price)}</div>
        </div>
      </div>
    `).join('');

    if (footer) footer.style.display = 'block';
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
  }

  // Initial cart count
  fetch('/cart.js').then(r=>r.json()).then(c => updateCartCount(c.item_count)).catch(()=>{});

  /* ── FAQ ── */
  window.toggleFaq = function(btn) {
    const item = btn.parentElement;
    const wasOpen = item.classList.contains('open');
    document.querySelectorAll('.faq-item').forEach(i => i.classList.remove('open'));
    if (!wasOpen) item.classList.add('open');
  };

});
